import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import EquipmentForm from "../component/equipmentform";
import Equipment_table from "../component/equipment_table";
import { dash, pictureUrls } from "../component/displayValue";
import "../component/css/listing-table.css";

const ProductDetail = () => {
  const { state } = useLocation();
  // Accept either the raw record or the display props object used by older links.
  const loadedProduct = state?.equipmentData?.data || state?.equipmentData || null;
  const hasProduct = Boolean(loadedProduct);
  const product = loadedProduct || {};
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [largeImageLoaded, setLargeImageLoaded] = useState(false);
  const [smallImagesLoaded, setSmallImagesLoaded] = useState(false);

  const handleLargeImageLoad = () => {
    setLargeImageLoaded(true);
  };

  const handleSmallImageLoad = () => {
    setSmallImagesLoaded(true);
  };

  const fetchData = async (page) => {

    try {
      setLoading(true);

      const response = await fetch(
        `/server/manufacturer-list/equipement-listings-details?page=1&search=`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log(response);
      console.log(responseData);
      if (responseData.error) {
        console.error("Error fetching data:", responseData.error);
      } else {
        setRelatedProducts(responseData.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);






  // console.log(product);
  const defaultImage = "";
  const images = pictureUrls(product);

  const hasImages = images.length > 0;

  const [selectedImage, setSelectedImage] = useState(
    hasImages ? images[0] || defaultImage : defaultImage
  );
  const [selectedThumbnail, setSelectedThumbnail] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [showInquiryModal, setShowInquiryModal] = useState(false);

  const values = {
    jad_id: product.JAD_ID,
    description: product.Description,
    model: product.Model,
    vintage: product.Vintage,
    Inspection_Available: product.Inspection_Available,
    Condition: product.Condition,
    Manufacturer: product.Manufacturer,
    thumb: images[0],
  };

  const handleThumbnailClick = (largeImage, index) => {
    setSelectedImage(largeImage);
    setSelectedThumbnail(index);
  };
  const handleRightButtonClick = () => {
    if (startIndex < smallImages.length - 4) {
      setStartIndex(startIndex + 1);
    }
  };

  const handleLeftButtonClick = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);

    }
  };

  const [isZoomedIn, setIsZoomedIn] = useState(false);

  const handleLargeImageClick = () => {
    setIsZoomedIn(!isZoomedIn);
  };
  const handleCloseButtonClick = () => {
    setIsZoomedIn(false);
  };
  const handleLargeImageChange = (direction) => {
    const newIndex =
      direction === "next" ? selectedThumbnail + 1 : selectedThumbnail - 1;

    if (newIndex >= 0 && newIndex < images.length) {
      setSelectedImage(images[newIndex] || defaultImage);
      setSelectedThumbnail(newIndex);
    }
  };

  const handleInquireButtonClick = () => {
    setShowInquiryModal(true);
  };

  const handleCloseInquiryModal = () => {
    setShowInquiryModal(false);
  };
  const smallImages = images;

  const hasSmallImages = smallImages.length > 0;
  const related_product_data_html =
    relatedProducts && Array.isArray(relatedProducts) && relatedProducts.length > 0 ? (
      relatedProducts.slice(0, 5).map((value, index) => (
        <Equipment_table
          key={value["JAD_ID"] || index}
          data={value}
          jad_id={value["JAD_ID"]}
          description={value.Description}
          model={value.Model}
          vintage={value.Vintage}
          Inspection_Available={value.Is_Inspection_Available}
          Condition={value.Condition}
          Manufacturer={value.Manufacturer}
          thumb={pictureUrls(value)[0] || defaultImage}
          File={value.File}
        />
      ))
    ) : (
      <tr>
        <td colSpan={8} className="listing-empty">
          No other equipment from this manufacturer.
        </td>
      </tr>
    );

  useEffect(() => {

    setSelectedImage(images[0])
    setSelectedThumbnail(0)

  }, [product && product.Pictures]);

  if (!hasProduct) {
    return (
      <>
        <TopHeader />
        <Secondheader />
        <div className="banner-image">
          <h1>Equipment Available for Sale</h1>
        </div>
        <div className="no-result">
          <h1>No equipment details available</h1>
        </div>
      </>
    );
  }

  return (
    <>
      <TopHeader />
      <Secondheader />
      {hasImages && loading && !(largeImageLoaded && smallImagesLoaded) && (
        <div className="loading-bar">Loading...</div>
      )}

      <div className="banner-image">
        <h1>Equipment Available for Sale</h1>
      </div>
      <div className="Product_details_container">
        <div className="Display_box_product">
          <div className="Product_img_Box">
            {hasImages ? (
              <>
                <div className="large_img">
                  <div className={isZoomedIn ? "zoomed-in-container " : "zoomed_not"}>
                    <button className="close-button" onClick={handleCloseButtonClick}>
                      X
                    </button>
                    <img
                      src={selectedImage}
                      alt=""
                      onLoad={() => {
                        handleLargeImageLoad();
                        setLoading(false);
                      }}
                      className={isZoomedIn ? "zoomed-in" : ""}
                      onClick={handleLargeImageClick}
                    />
                  </div>
                  {images.length > 1 && (
                    <>
                      <button
                        onClick={() => handleLargeImageChange("prev")}
                        className="ButtOn large-image-button"
                      >
                        <span className="left_btn">&lsaquo;</span>
                      </button>
                      <button
                        onClick={() => handleLargeImageChange("next")}
                        className="ButtOn large-image-button"
                      >
                        <span className="Right_btn">&rsaquo;</span>
                      </button>
                    </>
                  )}
                </div>
                <div className="small_images">
                  {smallImages.slice(startIndex, startIndex + 4).map((image, index) => (
                    <img
                      key={index}
                      src={image || defaultImage}
                      alt={`Thumbnail ${index + 1}`}
                      onLoad={handleSmallImageLoad}
                      onClick={() =>
                        handleThumbnailClick(image || defaultImage, index + startIndex)
                      }
                      className={
                        selectedThumbnail === index + startIndex
                          ? "selected-thumbnail"
                          : ""
                      }
                    />
                  ))}
                  {smallImages.length > 4 && (
                    <>
                      <button
                        onClick={handleLeftButtonClick}
                        disabled={startIndex === 0}
                        className="ButtOn"
                      >
                        <span className="left_btn">&lsaquo;</span>
                      </button>
                      <button
                        onClick={handleRightButtonClick}
                        disabled={startIndex >= smallImages.length - 4}
                        className="ButtOn"
                      >
                        <span className="Right_btn">&rsaquo;</span>
                      </button>
                    </>
                  )}
                </div>
              </>
            ) : (
              <div className="detail-image-placeholder">
                <span>No image available</span>
              </div>
            )}
          </div>
          <div className="product_details_text">
            <h3>View Equipment</h3>
            <h4>
              <span>JAD-ID: </span>
              {dash(product.JAD_ID)}
            </h4>
            <h4>
              <span>Model: </span>
              {dash(product.Model)}
            </h4>
            <h4>
              <span>Vintage: </span>
              {dash(product.Vintage)}
            </h4>
            <h4>
              <span>Inspection Available: </span>
              {dash(product.Is_Inspection_Available)}
            </h4>
            <h4>
              <span>Condition: </span>
              {dash(product.Condition)}
            </h4>
            <h4>
              <span>Manufacturer: </span>
              {dash(product.Manufacturer)}
            </h4>

            {product.File ? (
              <a
                href={product.File}
                target="_blank"
                rel="noreferrer"
                className="Detailed"
              >
                Detailed Specifications:
              </a>
            ) : (
              <p className="Detailed detail-muted">
                Detailed Specifications: {dash(null)}
              </p>
            )}

            <p>{dash(product.Description)}</p>

            <button className="inquire-btn" onClick={handleInquireButtonClick}>
              INQUIRE
              <span style={{ marginLeft: "5px" }}>&rarr;</span>
            </button>

            <EquipmentForm
              showInquiryModal={showInquiryModal}
              handleCloseInquiryModal={handleCloseInquiryModal}
              values={values}
              producttype="equipment"
            />
          </div>
        </div>
        <div className="Manufacturer_box">
          <h1>More from the Manufacturer</h1>
          <div className="listing-table-wrap">
            <table className="listing-table">
              <colgroup>
                <col style={{ width: "8%" }} />
                <col style={{ width: "26%" }} />
                <col style={{ width: "11%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "13%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th>Equipment</th>
                  <th>Model</th>
                  <th>Vintage</th>
                  <th>Inspection Available</th>
                  <th>Condition</th>
                  <th>Manufacturer</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{related_product_data_html}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetail;
